    const buyNowButton = document.querySelector('.shopify-payment-button__button')
    const addToCartButton = document.querySelector('.btn--full.add-to-cart')


    window.addEventListener("scroll", ()=>{

        const scrollVertical = window.scrollY
        const innerWidth = window.innerWidth
      console.log(scrollVertical)
      if (scrollVertical > 1400 && scrollVertical < 3824 && innerWidth < 500 ){
            buyNowButton.classList.add('buy_now_button__dynamic');
            addToCartButton.classList.add('add_to_cart_button__dynamic')
      }
      else{
        buyNowButton.classList.remove('buy_now_button__dynamic');
            addToCartButton.classList.remove('add_to_cart_button__dynamic')
      }
    })